import { ExpiredOfflineObjectAsyncTimestampRemover } from '../abstract/expired-offline-object-async-timestamp-remover';
import { ImmoIPTourOrderChangesObject } from './immo-ip-tour-order-changes-object';

export class ExpiredImmoIPTourOrderChangesRemover extends ExpiredOfflineObjectAsyncTimestampRemover<
  number,
  ImmoIPTourOrderChangesObject
> {}
